/**
 * 搬入・引取
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/requests`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    /**
     * 検索パラメータ
     */
    condition: {
      // 抽出種別
      search_type: null,
      // 運搬先事業者ID（必須）
      c_trader_id: null,
      // 運搬先事業場コード（必須）
      c_trader_location_code: null,
      // 処分事業者ID
      c_disposal_id: null,
      // 処分事業場コード
      c_disposal_location_code: null,
      // 積替後配車対象
      c_in_house_transshipment: false,
      // 事業場（積替えONで表示）
      c_location_code: null,
      // マニフェスト区分
      c_manifest_type: null,
      // マニフェストID
      c_manifest_id: null,
      // 並び替え
      c_sort_type: 'updated',
      // 回収日（From）
      c_start_date: null,
      // 回収日（To）
      c_end_date: null,
      // 品目
      c_item_id: null,
      // 引取搬入番号発番済も表示
      c_with_published: false,
      // 引取搬入番号
      c_request_no: null,
      // カスタムラベル①
      c_custom_labels_1: null,
      // カスタムラベル②
      c_custom_labels_2: null,
      // カスタムラベル③
      c_custom_labels_3: null,
      // カスタムラベル④
      c_custom_labels_4: null,
      // カスタムラベル⑤
      c_custom_labels_5: null,
      // カスタムラベル⑥
      c_custom_labels_6: null,
      // カスタムラベル①未設定
      c_custom_labels_1_unregistered: null,
      // カスタムラベル②未設定
      c_custom_labels_2_unregistered: null,
      // カスタムラベル③未設定
      c_custom_labels_3_unregistered: null,
      // カスタムラベル④未設定
      c_custom_labels_4_unregistered: null,
      // カスタムラベル⑤未設定
      c_custom_labels_5_unregistered: null,
      // カスタムラベル⑥未設定
      c_custom_labels_6_unregistered: null,
      // 運搬完了済を含む
      c_include_completed: false,  

      // 事業場コード（引き取り場所）必須
      p_location_code: null,
      // 引取業者（必須）
      p_transporter_id: null,
      // 運搬先事業者ID（必須）
      p_trader_id: null,
      // 運搬先事業場コード（必須）
      p_trader_location_code: null,
      // 処分事業者ID
      p_disposal_id: null,
      // 処分事業場コード
      p_disposal_location_code: null,
      // マニフェスト区分
      p_manifest_type: null,
      // マニフェストID
      p_manifest_id: null,
      // 並び替え
      p_sort_type: 'updated',
      // 回収日（From）
      p_start_date: null,
      // 回収日（To）
      p_end_date: null,
      // 品目
      p_item_id: null,
      // 引取搬入番号発番済も表示
      p_with_published: false,
      // 引取搬入番号
      p_request_no: null,
      // カスタムラベル①
      p_custom_labels_1: null,
      // カスタムラベル②
      p_custom_labels_2: null,
      // カスタムラベル③
      p_custom_labels_3: null,
      // カスタムラベル④
      p_custom_labels_4: null,
      // カスタムラベル⑤
      p_custom_labels_5: null,
      // カスタムラベル⑥
      p_custom_labels_6: null,
      // カスタムラベル①未設定
      p_custom_labels_1_unregistered: null,
      // カスタムラベル②未設定
      p_custom_labels_2_unregistered: null,
      // カスタムラベル③未設定
      p_custom_labels_3_unregistered: null,
      // カスタムラベル④未設定
      p_custom_labels_4_unregistered: null,
      // カスタムラベル⑤未設定
      p_custom_labels_5_unregistered: null,
      // カスタムラベル⑥未設定
      p_custom_labels_6_unregistered: null,
    },
    // チェックボックス ONリスト
    selectedItems: [],
  }
}

const manifest_request = {

  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 搬入・引取一覧
     * @param dispatch
     * @param commit
     * @param state
     * @param search_type
     * @param c_trader_id
     * @param c_trader_location_code
     * @param c_disposal_id
     * @param c_disposal_location_code
     * @param c_in_house_transshipment
     * @param c_location_code
     * @param c_manifest_type
     * @param c_manifest_id
     * @param c_sort_type
     * @param c_start_date
     * @param c_end_date
     * @param c_item_id
     * @param c_with_published
     * @param c_request_no
     * @param c_custom_labels_1
     * @param c_custom_labels_2
     * @param c_custom_labels_3
     * @param c_custom_labels_4
     * @param c_custom_labels_5
     * @param c_custom_labels_6
     * @param c_custom_labels_1_unregistered
     * @param c_custom_labels_2_unregistered
     * @param c_custom_labels_3_unregistered
     * @param c_custom_labels_4_unregistered
     * @param c_custom_labels_5_unregistered
     * @param c_custom_labels_6_unregistered
     * @param c_include_completed
     * @param p_location_code
     * @param p_transporter_id
     * @param p_trader_id
     * @param p_trader_location_code
     * @param p_disposal_id
     * @param p_disposal_location_code
     * @param p_manifest_type
     * @param p_manifest_id
     * @param p_sort_type
     * @param p_start_date
     * @param p_end_date
     * @param p_item_id
     * @param p_with_published
     * @param p_request_no
     * @param p_custom_labels_1
     * @param p_custom_labels_2
     * @param p_custom_labels_3
     * @param p_custom_labels_4
     * @param p_custom_labels_5
     * @param p_custom_labels_6
     * @param p_custom_labels_1_unregistered
     * @param p_custom_labels_2_unregistered
     * @param p_custom_labels_3_unregistered
     * @param p_custom_labels_4_unregistered
     * @param p_custom_labels_5_unregistered
     * @param p_custom_labels_6_unregistered
     * @param page
     * @param limit
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, {
      search_type, c_trader_id, c_trader_location_code, c_disposal_id, c_disposal_location_code, c_in_house_transshipment, c_location_code, c_manifest_type, c_sort_type,
      c_start_date, c_end_date, c_item_id, c_with_published, c_request_no, c_manifest_id,
      c_custom_labels_1, c_custom_labels_2, c_custom_labels_3, c_custom_labels_4, c_custom_labels_5, c_custom_labels_6,
      c_custom_labels_1_unregistered, c_custom_labels_2_unregistered, c_custom_labels_3_unregistered, c_custom_labels_4_unregistered, c_custom_labels_5_unregistered, c_custom_labels_6_unregistered,c_include_completed,
      p_location_code, p_transporter_id, p_trader_id, p_trader_location_code, p_disposal_id, p_disposal_location_code, p_manifest_type, p_sort_type, p_start_date, p_end_date,
      p_item_id, p_with_published, p_request_no, p_manifest_id,
      p_custom_labels_1, p_custom_labels_2, p_custom_labels_3, p_custom_labels_4, p_custom_labels_5, p_custom_labels_6,
      p_custom_labels_1_unregistered, p_custom_labels_2_unregistered, p_custom_labels_3_unregistered, p_custom_labels_4_unregistered, p_custom_labels_5_unregistered, p_custom_labels_6_unregistered,
      page, limit
    }) {
      dispatch('saveCondition', {
        search_type: search_type,
        c_trader_id: c_trader_id,
        c_trader_location_code: c_trader_location_code,
        c_disposal_id: c_disposal_id,
        c_disposal_location_code: c_disposal_location_code,
        c_in_house_transshipment: c_in_house_transshipment,
        c_location_code: c_location_code,
        c_manifest_type: c_manifest_type,
        c_manifest_id: c_manifest_id,
        c_sort_type: c_sort_type,
        c_start_date: c_start_date,
        c_end_date: c_end_date,
        c_item_id: c_item_id,
        c_with_published: c_with_published,
        c_request_no: c_request_no,
        c_custom_labels_1: c_custom_labels_1,
        c_custom_labels_2: c_custom_labels_2,
        c_custom_labels_3: c_custom_labels_3,
        c_custom_labels_4: c_custom_labels_4,
        c_custom_labels_5: c_custom_labels_5,
        c_custom_labels_6: c_custom_labels_6,
        c_custom_labels_1_unregistered: c_custom_labels_1_unregistered,
        c_custom_labels_2_unregistered: c_custom_labels_2_unregistered,
        c_custom_labels_3_unregistered: c_custom_labels_3_unregistered,
        c_custom_labels_4_unregistered: c_custom_labels_4_unregistered,
        c_custom_labels_5_unregistered: c_custom_labels_5_unregistered,
        c_custom_labels_6_unregistered: c_custom_labels_6_unregistered,
        c_include_completed: c_include_completed,

        p_location_code: p_location_code,
        p_transporter_id: p_transporter_id,
        p_trader_id: p_trader_id,
        p_trader_location_code: p_trader_location_code,
        p_disposal_id: p_disposal_id,
        p_disposal_location_code: p_disposal_location_code,
        p_manifest_type: p_manifest_type,
        p_manifest_id: p_manifest_id,
        p_sort_type: p_sort_type,
        p_start_date: p_start_date,
        p_end_date: p_end_date,
        p_item_id: p_item_id,
        p_with_published: p_with_published,
        p_request_no: p_request_no,
        p_custom_labels_1: p_custom_labels_1,
        p_custom_labels_2: p_custom_labels_2,
        p_custom_labels_3: p_custom_labels_3,
        p_custom_labels_4: p_custom_labels_4,
        p_custom_labels_5: p_custom_labels_5,
        p_custom_labels_6: p_custom_labels_6,
        p_custom_labels_1_unregistered: p_custom_labels_1_unregistered,
        p_custom_labels_2_unregistered: p_custom_labels_2_unregistered,
        p_custom_labels_3_unregistered: p_custom_labels_3_unregistered,
        p_custom_labels_4_unregistered: p_custom_labels_4_unregistered,
        p_custom_labels_5_unregistered: p_custom_labels_5_unregistered,
        p_custom_labels_6_unregistered: p_custom_labels_6_unregistered,
      })
      const params = {
        search_type: state.condition.search_type,
        c_trader_id: state.condition.c_trader_id,
        c_trader_location_code: state.condition.c_trader_location_code,
        c_disposal_id: state.condition.c_disposal_id,
        c_disposal_location_code: state.condition.c_disposal_location_code,
        c_in_house_transshipment: state.condition.c_in_house_transshipment,
        c_location_code: state.condition.c_location_code,
        c_manifest_type: state.condition.c_manifest_type,
        c_manifest_id: state.condition.c_manifest_id,
        c_sort_type: state.condition.c_sort_type,
        c_start_date: state.condition.c_start_date,
        c_end_date: state.condition.c_end_date,
        c_item_id: state.condition.c_item_id,
        c_with_published: state.condition.c_with_published,
        c_request_no: state.condition.c_request_no,
        c_custom_labels_1: state.condition.c_custom_labels_1,
        c_custom_labels_2: state.condition.c_custom_labels_2,
        c_custom_labels_3: state.condition.c_custom_labels_3,
        c_custom_labels_4: state.condition.c_custom_labels_4,
        c_custom_labels_5: state.condition.c_custom_labels_5,
        c_custom_labels_6: state.condition.c_custom_labels_6,
        c_custom_labels_1_unregistered: state.condition.c_custom_labels_1_unregistered,
        c_custom_labels_2_unregistered: state.condition.c_custom_labels_2_unregistered,
        c_custom_labels_3_unregistered: state.condition.c_custom_labels_3_unregistered,
        c_custom_labels_4_unregistered: state.condition.c_custom_labels_4_unregistered,
        c_custom_labels_5_unregistered: state.condition.c_custom_labels_5_unregistered,
        c_custom_labels_6_unregistered: state.condition.c_custom_labels_6_unregistered,
        c_include_completed: state.condition.c_include_completed,

        p_location_code: state.condition.p_location_code,
        p_transporter_id: state.condition.p_transporter_id,
        p_trader_id: state.condition.p_trader_id,
        p_trader_location_code: state.condition.p_trader_location_code,
        p_disposal_id: state.condition.p_disposal_id,
        p_disposal_location_code: state.condition.p_disposal_location_code,
        p_manifest_type: state.condition.p_manifest_type,
        p_manifest_id: state.condition.p_manifest_id,
        p_sort_type: state.condition.p_sort_type,
        p_start_date: state.condition.p_start_date,
        p_end_date: state.condition.p_end_date,
        p_item_id: state.condition.p_item_id,
        p_with_published: state.condition.p_with_published,
        p_request_no: state.condition.p_request_no,
        p_custom_labels_1: state.condition.p_custom_labels_1,
        p_custom_labels_2: state.condition.p_custom_labels_2,
        p_custom_labels_3: state.condition.p_custom_labels_3,
        p_custom_labels_4: state.condition.p_custom_labels_4,
        p_custom_labels_5: state.condition.p_custom_labels_5,
        p_custom_labels_6: state.condition.p_custom_labels_6,
        p_custom_labels_1_unregistered: state.condition.p_custom_labels_1_unregistered,
        p_custom_labels_2_unregistered: state.condition.p_custom_labels_2_unregistered,
        p_custom_labels_3_unregistered: state.condition.p_custom_labels_3_unregistered,
        p_custom_labels_4_unregistered: state.condition.p_custom_labels_4_unregistered,
        p_custom_labels_5_unregistered: state.condition.p_custom_labels_5_unregistered,
        p_custom_labels_6_unregistered: state.condition.p_custom_labels_6_unregistered,
        limit: limit,
        page: page
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
        let content = data.content
        commit(types.DRIVER_MANIFEST_REQUEST_PAGINATION, { content })
        resolve(content)
        })
      })
    },
    /**
     * 搬入・引取詳細
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 搬入・引取 引取搬入番号更新
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}`
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
     *搬入・引取 引取搬入番号削除
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    /**
     * 搬入・引取 引取搬入番号一括削除
     * @param commit
     * @param request_no
     * @return {Promise<unknown>}
     */
    removeRequestNo ({ commit }, { request_no }) {
      const api_path = `${API_PATH}/remove`
      const params = { request_no: request_no }
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path, {params: params}).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    /**
     * 検索パラメータの保存
     * @param commit
     * @param state
     * @param search_type
     * @param c_trader_id
     * @param c_trader_location_code
     * @param c_disposal_id
     * @param c_disposal_location_code
     * @param c_in_house_transshipment
     * @param c_location_id
     * @param c_manifest_type
     * @param c_manifest_id
     * @param c_sort_type
     * @param c_start_date
     * @param c_end_date
     * @param c_item_id
     * @param c_with_published
     * @param c_request_no
     * @param c_custom_labels_1
     * @param c_custom_labels_2
     * @param c_custom_labels_3
     * @param c_custom_labels_4
     * @param c_custom_labels_5
     * @param c_custom_labels_6
     * @param c_custom_labels_1_unregistered
     * @param c_custom_labels_2_unregistered
     * @param c_custom_labels_3_unregistered
     * @param c_custom_labels_4_unregistered
     * @param c_custom_labels_5_unregistered
     * @param c_custom_labels_6_unregistered
     * @param c_include_completed
     * @param p_location_code
     * @param p_transporter_id
     * @param p_trader_id
     * @param p_trader_location_code
     * @param p_disposal_id
     * @param p_disposal_location_code
     * @param p_manifest_type
     * @param p_manifest_id
     * @param p_sort_type
     * @param p_start_date
     * @param p_end_date
     * @param p_item_id
     * @param p_with_published
     * @param p_request_no
     * @param p_custom_labels_1
     * @param p_custom_labels_2
     * @param p_custom_labels_3
     * @param p_custom_labels_4
     * @param p_custom_labels_5
     * @param p_custom_labels_6
     * @param p_custom_labels_1_unregistered
     * @param p_custom_labels_2_unregistered
     * @param p_custom_labels_3_unregistered
     * @param p_custom_labels_4_unregistered
     * @param p_custom_labels_5_unregistered
     * @param p_custom_labels_6_unregistered
     */
    saveCondition ({ commit, state }, {
      search_type, c_trader_id, c_trader_location_code, c_disposal_id, c_disposal_location_code, c_in_house_transshipment, c_location_code, c_manifest_type, c_sort_type,
      c_start_date, c_end_date, c_item_id, c_with_published, c_request_no, c_manifest_id,
      c_custom_labels_1, c_custom_labels_2, c_custom_labels_3, c_custom_labels_4, c_custom_labels_5, c_custom_labels_6,
      c_custom_labels_1_unregistered, c_custom_labels_2_unregistered, c_custom_labels_3_unregistered, c_custom_labels_4_unregistered, c_custom_labels_5_unregistered, c_custom_labels_6_unregistered,c_include_completed,
      p_location_code, p_transporter_id, p_trader_id, p_trader_location_code, p_disposal_id, p_disposal_location_code, p_manifest_type, p_sort_type, p_start_date, p_end_date,
      p_item_id, p_with_published, p_request_no, p_manifest_id,
      p_custom_labels_1, p_custom_labels_2, p_custom_labels_3, p_custom_labels_4, p_custom_labels_5, p_custom_labels_6,
      p_custom_labels_1_unregistered, p_custom_labels_2_unregistered, p_custom_labels_3_unregistered, p_custom_labels_4_unregistered, p_custom_labels_5_unregistered, p_custom_labels_6_unregistered
    }) {
      const _search_type = (search_type !== undefined) ? search_type: state.condition.search_type
      const _c_trader_id = (c_trader_id !== undefined) ? c_trader_id: state.condition.c_trader_id
      const _c_trader_location_code = (c_trader_location_code !== undefined) ? c_trader_location_code: state.condition.c_trader_location_code
      const _c_disposal_id = (c_disposal_id !== undefined) ? c_disposal_id: state.condition.c_disposal_id
      const _c_disposal_location_code = (c_disposal_location_code !== undefined) ? c_disposal_location_code: state.condition.c_disposal_location_code
      const _c_in_house_transshipment = (c_in_house_transshipment !== undefined) ? c_in_house_transshipment : state.condition.c_in_house_transshipment
      const _c_location_code = (c_location_code !== undefined) ? c_location_code : state.condition.c_location_code
      const _c_manifest_type = (c_manifest_type !== undefined) ? c_manifest_type : state.condition.c_manifest_type
      const _c_manifest_id = (c_manifest_id !== undefined) ? c_manifest_id : state.condition.c_manifest_id
      const _c_sort_type = (c_sort_type !== undefined) ? c_sort_type : state.condition.c_sort_type
      const _c_start_date = (c_start_date !== undefined) ? c_start_date : state.condition.c_start_date
      const _c_end_date = (c_end_date !== undefined) ? c_end_date : state.condition.c_end_date
      const _c_item_id = (c_item_id !== undefined) ? c_item_id : state.condition.c_item_id
      const _c_with_published = (c_with_published !== undefined) ? c_with_published : state.condition.c_with_published
      const _c_request_no = (c_request_no !== undefined) ? c_request_no : state.condition.c_request_no
      const _c_custom_labels_1 = (c_custom_labels_1 !== undefined) ? c_custom_labels_1 : state.condition.c_custom_labels_1
      const _c_custom_labels_2 = (c_custom_labels_2 !== undefined) ? c_custom_labels_2 : state.condition.c_custom_labels_2
      const _c_custom_labels_3 = (c_custom_labels_3 !== undefined) ? c_custom_labels_3 : state.condition.c_custom_labels_3
      const _c_custom_labels_4 = (c_custom_labels_4 !== undefined) ? c_custom_labels_4 : state.condition.c_custom_labels_4
      const _c_custom_labels_5 = (c_custom_labels_5 !== undefined) ? c_custom_labels_5 : state.condition.c_custom_labels_5
      const _c_custom_labels_6 = (c_custom_labels_6 !== undefined) ? c_custom_labels_6 : state.condition.c_custom_labels_6
      const _c_custom_labels_1_unregistered = (c_custom_labels_1_unregistered !== undefined) ? c_custom_labels_1_unregistered : state.condition.c_custom_labels_1_unregistered
      const _c_custom_labels_2_unregistered = (c_custom_labels_2_unregistered !== undefined) ? c_custom_labels_2_unregistered : state.condition.c_custom_labels_2_unregistered
      const _c_custom_labels_3_unregistered = (c_custom_labels_3_unregistered !== undefined) ? c_custom_labels_3_unregistered : state.condition.c_custom_labels_3_unregistered
      const _c_custom_labels_4_unregistered = (c_custom_labels_4_unregistered !== undefined) ? c_custom_labels_4_unregistered : state.condition.c_custom_labels_4_unregistered
      const _c_custom_labels_5_unregistered = (c_custom_labels_5_unregistered !== undefined) ? c_custom_labels_5_unregistered : state.condition.c_custom_labels_5_unregistered
      const _c_custom_labels_6_unregistered = (c_custom_labels_6_unregistered !== undefined) ? c_custom_labels_6_unregistered : state.condition.c_custom_labels_6_unregistered
      const _c_include_completed = (c_include_completed !== undefined) ? c_include_completed : state.condition.c_include_completed
      const _p_location_code = (p_location_code !== undefined) ? p_location_code : state.condition.p_location_code
      const _p_transporter_id = (p_transporter_id !== undefined) ? p_transporter_id : state.condition.p_transporter_id
      const _p_trader_id = (p_trader_id !== undefined) ? p_trader_id : state.condition.p_trader_id
      const _p_trader_location_code = (p_trader_location_code !== undefined) ? p_trader_location_code : state.condition.p_trader_location_code
      const _p_disposal_id = (p_disposal_id !== undefined) ? p_disposal_id : state.condition.p_disposal_id
      const _p_disposal_location_code = (p_disposal_location_code !== undefined) ? p_disposal_location_code : state.condition.p_disposal_location_code
      const _p_manifest_type = (p_manifest_type !== undefined) ? p_manifest_type : state.condition.p_manifest_type
      const _p_manifest_id = (p_manifest_id !== undefined) ? p_manifest_id : state.condition.p_manifest_id
      const _p_sort_type = (p_sort_type !== undefined) ? p_sort_type : state.condition.p_sort_type
      const _p_start_date = (p_start_date !== undefined) ? p_start_date : state.condition.p_start_date
      const _p_end_date = (p_end_date !== undefined) ? p_end_date : state.condition.p_end_date
      const _p_item_id = (p_item_id !== undefined) ? p_item_id : state.condition.p_item_id
      const _p_with_published = (p_with_published !== undefined) ? p_with_published : state.condition.p_with_published
      const _p_request_no = (p_request_no !== undefined) ? p_request_no : state.condition.p_request_no
      const _p_custom_labels_1 = (p_custom_labels_1 !== undefined) ? p_custom_labels_1 : state.condition.p_custom_labels_1
      const _p_custom_labels_2 = (p_custom_labels_2 !== undefined) ? p_custom_labels_2 : state.condition.p_custom_labels_2
      const _p_custom_labels_3 = (p_custom_labels_3 !== undefined) ? p_custom_labels_3 : state.condition.p_custom_labels_3
      const _p_custom_labels_4 = (p_custom_labels_4 !== undefined) ? p_custom_labels_4 : state.condition.p_custom_labels_4
      const _p_custom_labels_5 = (p_custom_labels_5 !== undefined) ? p_custom_labels_5 : state.condition.p_custom_labels_5
      const _p_custom_labels_6 = (p_custom_labels_6 !== undefined) ? p_custom_labels_6 : state.condition.p_custom_labels_6
      const _p_custom_labels_1_unregistered = (p_custom_labels_1_unregistered !== undefined) ? p_custom_labels_1_unregistered : state.condition.p_custom_labels_1_unregistered
      const _p_custom_labels_2_unregistered = (p_custom_labels_2_unregistered !== undefined) ? p_custom_labels_2_unregistered : state.condition.p_custom_labels_2_unregistered
      const _p_custom_labels_3_unregistered = (p_custom_labels_3_unregistered !== undefined) ? p_custom_labels_3_unregistered : state.condition.p_custom_labels_3_unregistered
      const _p_custom_labels_4_unregistered = (p_custom_labels_4_unregistered !== undefined) ? p_custom_labels_4_unregistered : state.condition.p_custom_labels_4_unregistered
      const _p_custom_labels_5_unregistered = (p_custom_labels_5_unregistered !== undefined) ? p_custom_labels_5_unregistered : state.condition.p_custom_labels_5_unregistered
      const _p_custom_labels_6_unregistered = (p_custom_labels_6_unregistered !== undefined) ? p_custom_labels_6_unregistered : state.condition.p_custom_labels_6_unregistered
      const params = {
        search_type: _search_type,
        c_trader_id: _c_trader_id,
        c_trader_location_code: _c_trader_location_code,
        c_disposal_id: _c_disposal_id,
        c_disposal_location_code: _c_disposal_location_code,
        c_in_house_transshipment: _c_in_house_transshipment,
        c_location_code: _c_location_code,
        c_manifest_type: _c_manifest_type,
        c_manifest_id: _c_manifest_id,
        c_sort_type: _c_sort_type,
        c_start_date: _c_start_date,
        c_end_date: _c_end_date,
        c_item_id: _c_item_id,
        c_with_published: _c_with_published,
        c_request_no: _c_request_no,
        c_custom_labels_1: _c_custom_labels_1,
        c_custom_labels_2: _c_custom_labels_2,
        c_custom_labels_3: _c_custom_labels_3,
        c_custom_labels_4: _c_custom_labels_4,
        c_custom_labels_5: _c_custom_labels_5,
        c_custom_labels_6: _c_custom_labels_6,
        c_custom_labels_1_unregistered: _c_custom_labels_1_unregistered,
        c_custom_labels_2_unregistered: _c_custom_labels_2_unregistered,
        c_custom_labels_3_unregistered: _c_custom_labels_3_unregistered,
        c_custom_labels_4_unregistered: _c_custom_labels_4_unregistered,
        c_custom_labels_5_unregistered: _c_custom_labels_5_unregistered,
        c_custom_labels_6_unregistered: _c_custom_labels_6_unregistered,
        c_include_completed: _c_include_completed,
        p_location_code: _p_location_code,
        p_transporter_id: _p_transporter_id,
        p_trader_id: _p_trader_id,
        p_trader_location_code: _p_trader_location_code,
        p_disposal_id: _p_disposal_id,
        p_disposal_location_code: _p_disposal_location_code,
        p_manifest_type: _p_manifest_type,
        p_manifest_id: _p_manifest_id,
        p_sort_type: _p_sort_type,
        p_start_date: _p_start_date,
        p_end_date: _p_end_date,
        p_item_id: _p_item_id,
        p_with_published: _p_with_published,
        p_request_no: _p_request_no,
        p_custom_labels_1: _p_custom_labels_1,
        p_custom_labels_2: _p_custom_labels_2,
        p_custom_labels_3: _p_custom_labels_3,
        p_custom_labels_4: _p_custom_labels_4,
        p_custom_labels_5: _p_custom_labels_5,
        p_custom_labels_6: _p_custom_labels_6,
        p_custom_labels_1_unregistered: _p_custom_labels_1_unregistered,
        p_custom_labels_2_unregistered: _p_custom_labels_2_unregistered,
        p_custom_labels_3_unregistered: _p_custom_labels_3_unregistered,
        p_custom_labels_4_unregistered: _p_custom_labels_4_unregistered,
        p_custom_labels_5_unregistered: _p_custom_labels_5_unregistered,
        p_custom_labels_6_unregistered: _p_custom_labels_6_unregistered,
      }
      commit(types.DRIVER_MANIFEST_REQUEST_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_MANIFEST_REQUEST_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_MANIFEST_REQUEST_RESET_PAGINATION)
    },
    setItems ({ commit }, { id, section_no }) {
      commit(types.DRIVER_MANIFEST_REQUEST_SET_ITEM, { id, section_no})
    },
    removeItem({ commit }, { id, section_no }) {
      commit(types.DRIVER_MANIFEST_REQUEST_REMOVE_ITEM, { id, section_no})
    },
    allRemoveItems({ commit }) {
      commit(types.DRIVER_MANIFEST_REQUEST_ALL_REMOVE_ITEMS)
    }
  },
  mutations: {
    /**
     * ページ情報の設定
     * @param state
     * @param content
     */
    [types.DRIVER_MANIFEST_REQUEST_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    /**
     * ページ情報のリセット
     * @param state
     */
    [types.DRIVER_MANIFEST_REQUEST_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    /**
     * 検索条件の設定
     * @param state
     * @param params
     */
    [types.DRIVER_MANIFEST_REQUEST_CONDITION] (state, { params }) {
      state.condition.search_type = params.search_type
      state.condition.c_trader_id = params.c_trader_id
      state.condition.c_trader_location_code = params.c_trader_location_code
      state.condition.c_disposal_id= params.c_disposal_id
      state.condition.c_disposal_location_code= params.c_disposal_location_code
      state.condition.c_in_house_transshipment = params.c_in_house_transshipment
      state.condition.c_location_code = params.c_location_code
      state.condition.c_manifest_type = params.c_manifest_type
      state.condition.c_manifest_id = params.c_manifest_id
      state.condition.c_sort_type = params.c_sort_type
      state.condition.c_start_date = params.c_start_date
      state.condition.c_end_date = params.c_end_date
      state.condition.c_item_id = params.c_item_id
      state.condition.c_with_published = params.c_with_published
      state.condition.c_request_no = params.c_request_no
      state.condition.c_custom_labels_1 = params.c_custom_labels_1
      state.condition.c_custom_labels_2 = params.c_custom_labels_2
      state.condition.c_custom_labels_3 = params.c_custom_labels_3
      state.condition.c_custom_labels_4 = params.c_custom_labels_4
      state.condition.c_custom_labels_5 = params.c_custom_labels_5
      state.condition.c_custom_labels_6 = params.c_custom_labels_6
      state.condition.c_custom_labels_1_unregistered = params.c_custom_labels_1_unregistered
      state.condition.c_custom_labels_2_unregistered = params.c_custom_labels_2_unregistered
      state.condition.c_custom_labels_3_unregistered = params.c_custom_labels_3_unregistered
      state.condition.c_custom_labels_4_unregistered = params.c_custom_labels_4_unregistered
      state.condition.c_custom_labels_5_unregistered = params.c_custom_labels_5_unregistered
      state.condition.c_custom_labels_6_unregistered = params.c_custom_labels_6_unregistered
      state.condition.c_include_completed = params.c_include_completed

      state.condition.p_location_code = params.p_location_code
      state.condition.p_transporter_id = params.p_transporter_id
      state.condition.p_trader_id = params.p_trader_id
      state.condition.p_trader_location_code = params.p_trader_location_code
      state.condition.p_disposal_id = params.p_disposal_id
      state.condition.p_disposal_location_code = params.p_disposal_location_code
      state.condition.p_manifest_type = params.p_manifest_type
      state.condition.p_manifest_id = params.p_manifest_id
      state.condition.p_sort_type = params.p_sort_type
      state.condition.p_start_date = params.p_start_date
      state.condition.p_end_date = params.p_end_date
      state.condition.p_item_id = params.p_item_id
      state.condition.p_with_published = params.p_with_published
      state.condition.p_request_no = params.p_request_no
      state.condition.p_custom_labels_1 = params.p_custom_labels_1
      state.condition.p_custom_labels_2 = params.p_custom_labels_2
      state.condition.p_custom_labels_3 = params.p_custom_labels_3
      state.condition.p_custom_labels_4 = params.p_custom_labels_4
      state.condition.p_custom_labels_5 = params.p_custom_labels_5
      state.condition.p_custom_labels_6 = params.p_custom_labels_6
      state.condition.p_custom_labels_1_unregistered = params.p_custom_labels_1_unregistered
      state.condition.p_custom_labels_2_unregistered = params.p_custom_labels_2_unregistered
      state.condition.p_custom_labels_3_unregistered = params.p_custom_labels_3_unregistered
      state.condition.p_custom_labels_4_unregistered = params.p_custom_labels_4_unregistered
      state.condition.p_custom_labels_5_unregistered = params.p_custom_labels_5_unregistered
      state.condition.p_custom_labels_6_unregistered = params.p_custom_labels_6_unregistered
  },
    /**
     * 検索条件のリセット
     * @param state
     */
    [types.DRIVER_MANIFEST_REQUEST_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    /**
     * チェックボックス設定(チェックONにする)
     * @param state
     * @param content
     */
    [types.DRIVER_MANIFEST_REQUEST_SET_ITEM] (state, { id, section_no }) {
      state.selectedItems.push(id, section_no)
    },
    /**
     * チェックボックス設定(チェックOFFにする)
     * @param state
     * @param id
     */
    [types.DRIVER_MANIFEST_REQUEST_REMOVE_ITEM] (state, { id, section_no }) {
      state.selectedItems = state.selectedItems.filter(v => v != id && v != section_no)
    },
    /**
     * チェックボックス設定(全部チェックOFFにする)
     * @param state
     */
    [types.DRIVER_MANIFEST_REQUEST_ALL_REMOVE_ITEMS] (state) {
      state.selectedItems = []
    },
  },

}

export default manifest_request
